import React, { useState } from 'react'

// Import image assets
import loaderAnim from './images/ll-image-loader-anim.gif'
import defaultCustomPlaceHolder from './images/default-custom-placeholder.png'
import defaultCustomItemPlaceHolder from './images/default-custom-item-placeholder.png'
import defaultOffersPlaceHolder from './images/default-offers-placeholder.png'
import defaultProductPlaceHolder from './images/default-product-placeholder.png'
import { type StaticImageData } from 'next/image'

type ImageType = 'PRODUCT' | 'OFFER' | 'CUSTOM_OFFER' | 'CATEGORY' | 'CUSTOM_ITEM' | 'STORE' | 'CUSTOM'

interface CustomImageProps {
  imageType: ImageType
  imageUrl: string
  imageStyle?: string
  imageAlt?: string
  imageTitle?: string
}

const errorImageFallback = (event: React.SyntheticEvent<HTMLImageElement>, fallbackImageSrc: string): void => {
  event.currentTarget.src = fallbackImageSrc
}

const CustomImage: React.FC<CustomImageProps> = ({
  imageType,
  imageUrl,
  imageStyle = '',
  imageAlt = '',
  imageTitle = ''
}) => {
  const [isImageLoading, setIsImageLoading] = useState(true)

  let fallbackImage: StaticImageData = defaultCustomPlaceHolder

  switch (imageType) {
    case 'PRODUCT':
    case 'CATEGORY':
      fallbackImage = defaultProductPlaceHolder
      break
    case 'OFFER':
      fallbackImage = defaultOffersPlaceHolder
      break
    case 'CUSTOM_ITEM':
      fallbackImage = defaultCustomItemPlaceHolder
      break
    case 'CUSTOM_OFFER':
    default:
      fallbackImage = defaultCustomPlaceHolder
      break
  }

  return (
    <img
      className={imageStyle}
      alt={imageAlt}
      title={imageTitle}
      src={isImageLoading ? loaderAnim.src : imageUrl}
      onError={(event) => { errorImageFallback(event, fallbackImage.src) }}
      onLoad={() => { setIsImageLoading(false) }}
    />
  )
}

export default CustomImage
